var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_878_4534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.667 4.9974C11.667 5.88145 12.0182 6.7293 12.6433 7.35442C13.2684 7.97954 14.1163 8.33073 15.0003 8.33073C15.8844 8.33073 16.7322 7.97954 17.3573 7.35442C17.9825 6.7293 18.3337 5.88145 18.3337 4.9974C18.3337 4.11334 17.9825 3.26549 17.3573 2.64037C16.7322 2.01525 15.8844 1.66406 15.0003 1.66406C14.1163 1.66406 13.2684 2.01525 12.6433 2.64037C12.0182 3.26549 11.667 4.11334 11.667 4.9974Z",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91699 18.332H11.2503",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0003 10.8322V11.6656L16.667 14.9989H1.66699L3.33366 11.6656V7.49889C3.33344 6.6623 3.51318 5.83545 3.86067 5.07444C4.20816 4.31343 4.71528 3.63606 5.34761 3.0883C5.97995 2.54054 6.72271 2.1352 7.52549 1.89978C8.32828 1.66437 9.17231 1.60438 10.0003 1.72389",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_878_4534"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.f90dc1ceca6e6026a68e668f554f6392.svg";
export { ForwardRef as ReactComponent };